export default "__VITE_ASSET__2cCgrB9w__"